import { Clipboard } from '@angular/cdk/clipboard';
import { Component, OnInit } from '@angular/core';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { CountriesCurrenciesService } from '@app/finxone-web-frontend/app/lib/services/countries-currencies-service/countries-currencies.service';
import {
  buildHandleBarModel,
  filterIfHandlebarNotRendered,
} from '@app/finxone-web-frontend/app/lib/utils/template/model-builder.utils';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { AlertHandlerService, IconCacheService } from '@finxone-platform/shared/services';
import {
  BaseCssProperties,
  ProviderClass,
  WidgetLayoutAttributes,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import Handlebars from 'handlebars';
import { Subject, takeUntil } from 'rxjs';
import { BaseComponent } from '../base/base.component';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-copy-share-content-widget',
  templateUrl: './copy-share-content-widget.component.html',
})
export class CopyShareContentWidgetComponent extends BaseComponent implements OnInit {
  private flutterWebView = (window as any).flutter_inappwebview;
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  public copyContentTemplate: string;
  public textContentTemplate: string;
  public showShareSheet = false;
  public globalStylingClass: any;
  public isAllowedGlobalStyling: any;

  constructor(
    public dataIn: ProviderClass<WidgetLayoutAttributes>,
    private configService: ConfigService,
    private store: Store,
    private countriesCurrenciesService: CountriesCurrenciesService,
    private alertService: AlertHandlerService,
    private clipboard: Clipboard,
    private iconCacheService: IconCacheService,
  ) {
    super();
  }
  ngOnInit() {
    if (this.dataIn) {
      this.attri = this.dataIn.attri ?? null;
      this.loadConfigData();
      this.loadCssConfigData();
    }
  }

  public loadConfigData() {
    this.textContentTemplate = this.attri?.['textContent']?.textContentToDisplay;

    const template = Handlebars.compile(this.textContentTemplate);
    buildHandleBarModel(
      this.store,
      this.textContentTemplate,
      this.countriesCurrenciesService,
      this.iconCacheService,
    )
      .pipe(takeUntil(this.destroy$))
      .subscribe((model) => {
        this.textContentTemplate = filterIfHandlebarNotRendered(template(model));
      });

    this.buildCopyContentTemplate();

    this.showShareSheet = this.dataIn?.attri?.['showShareSheet'];
  }

  private buildCopyContentTemplate() {
    this.copyContentTemplate = this.attri?.['textContent']?.textContentToCopy;

    const template = Handlebars.compile(this.copyContentTemplate);
    buildHandleBarModel(
      this.store,
      this.copyContentTemplate,
      this.countriesCurrenciesService,
      this.iconCacheService,
    )
      .pipe(takeUntil(this.destroy$))
      .subscribe((model) => {
        this.copyContentTemplate = filterIfHandlebarNotRendered(template(model));
      });
  }

  private loadCssConfigData() {
    this.contentStyle = this.configService.getSpecificBaseCssStyle(this.attri, [
      BaseCssProperties.MARGIN,
      BaseCssProperties.PADDING,
      BaseCssProperties.BORDER,
      BaseCssProperties.COLOR,
      BaseCssProperties.TEXTALIGN,
      BaseCssProperties.BACKGROUND_COLOR,
      BaseCssProperties.BOX_SHADOW,
      BaseCssProperties.V_ALIGN,
      BaseCssProperties.COLOR,
      BaseCssProperties.FONT_SIZE,
      BaseCssProperties.TEXT_BOLD,
      BaseCssProperties.TEXT_ITALIC,
      BaseCssProperties.TEXT_UNDERLINE,
      BaseCssProperties.TEXT_FONT_STYLE,
    ]);

    this.getGlobalStyling();
  }

  private getGlobalStyling() {
    if (
      this.dataIn.attri?.widgetProperties?.['globalStylingClass'] &&
      this.dataIn.attri?.widgetProperties?.['globalStyling']
    ) {
      this.globalStylingClass = this.dataIn.attri?.widgetProperties?.['globalStylingClass'] ?? '';
      this.isAllowedGlobalStyling = this.dataIn.attri?.widgetProperties?.['globalStyling'] ?? false;
    }
  }

  public copyContent(copyContent: string) {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = copyContent;
    const textContent = tempElement.textContent ?? tempElement.innerText ?? '';

    if (this.showShareSheet) {
      if (this.flutterWebView) {
        this.flutterWebView.callHandler('shareSheetHandler', [textContent]);
      }
    } else {
      this.clipboard.copy(textContent);
      this.alertService.showAlertFn('success', 'Copied!');
    }
  }
}
